import axios from "axios";
import { UploadTasksRepository } from "../../repository/api/uploadtask/uploadtask";
import { actionCreators } from "../../state";
const FormData = require('form-data');

export class UploadTaskUseCases {
    private api: UploadTasksRepository;
    private stateActions: typeof actionCreators;

    constructor(api: UploadTasksRepository, stateActions: typeof actionCreators) {
        this.api = api;
        this.stateActions = stateActions;
    }

    public ReadUploadTasks = async () => {
        this.stateActions.SendUploadTaskListRequest()
        let response = await this.api.ReadUploadTasks()
        if (response instanceof Error) {
            this.stateActions.UploadTaskListError(response.message)
            return
        } else {
            this.stateActions.UploadTaskListSuccess(response)
        }
    }

    public DeleteUploadTask = async (id: UniqueId) => {
        this.stateActions.UploadTaskDeleteRequest()
        let response = await this.api.DeleteUploadTaskById(id)
        if (response instanceof Error) {
            this.stateActions.UploadTaskDeleteError(response.message)
            return
        } else {
            this.stateActions.UploadTaskDeleteSuccess(id)
        }
    }

    public ReadUploadTaskById = async (id: UniqueId) => {
        let response = await this.api.ReadUploadTaskById(id)
        return response
    }

    public ReadDirsTreeOfSite = async (id: UniqueId) => {
        let response = await this.api.ReadDirsTreeOfSite(id)
        return response
    }

    public ReadMonthsImagesOfSite = async (id: UniqueId, year: number, month: number) => {
        let response = await this.api.ReadMonthsImagesOfSite(id, year, month)
        return response
    }

    public ReadImageFromUrl = async (landingId: UniqueId, year: string, month: string, fileName: string, defaultType = 'image/jpeg') => {
        const response = await fetch(process.env.REACT_APP_BACKEND_URL + "/api/upload-task/"+landingId+"/image/"+year+"/"+month+"/"+fileName);
        const data = await response.blob();
        return new File([data], fileName, {
          type: data.type || defaultType,
        });
    }

    public UploadFiles = async (landingId: UniqueId, year: string, month: string, files: File[], callback?: ()=>void ) => {
        const formData = new FormData();
        files.forEach((file)=>{
            formData.append("files[]", file)
        })  

        const response = await axios.post(process.env.REACT_APP_BACKEND_URL + "/api/upload-task/"+landingId+"/image/"+year+"/"+month, formData, {
            headers: { "Authorization": localStorage.getItem("token")}
        });

        if (response.status == 200 && callback) {
            callback()
        }
    }

    public CreateUploadTask = async (siteId: string,month: number,year: number,tmpFolder: string,imageOrder: string[], callback?: ()=>void) => {
        this.stateActions.UploadTaskCreateRequest()
        let response = await this.api.CreateUploadTask(siteId,month,year,tmpFolder,imageOrder,)
        if (response instanceof Error) {
            this.stateActions.UploadTaskCreateError(response.message)
            return
        } else {
            this.stateActions.UploadTaskCreateSuccess(response)
            if (callback) {
                callback()
            }
        }
    }

    public UpdateUploadTask = async (id: UniqueId, siteId: string,month: number,year: number,tmpFolder: string,imageOrder: string[], callback?: ()=>void) => {
        this.stateActions.UploadTaskUpdateRequest()
        let response = await this.api.UpdateUploadTask(id, siteId,month,year,tmpFolder,imageOrder)
        if (response instanceof Error) {
            this.stateActions.UploadTaskUpdateError(response.message)
            return
        } else {
            this.stateActions.UploadTaskUpdateSuccess(response)
            if (callback) {
                callback()
            }
        }
    }

}